import React, { forwardRef } from 'react';
import { Icon } from '@chakra-ui/react';
import { QIconProps } from './Icon';
import { QTheme } from '../QTheme';

export const ResourceTask = forwardRef<SVGSVGElement, Partial<QIconProps>>(
  (props, ref) => {
    return (
      <Icon viewBox="0 0 16 16" color="currentColor" {...props} ref={ref}>
        <svg
          height="16"
          viewBox="0 0 16 16"
          width="16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect fill={QTheme.colors.gray[100]} height="16" rx="2" width="16" />
          <g
            fill="none"
            stroke={QTheme.colors.gray[700]}
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="m12.108 8.258a2.7 2.7 0 0 0 -3.8205-3.8205l-3.0375 3.0375v3.825h3.825z" />
            <path d="m10.2 6.35-6.3 6.3" />
            <path d="m10.875 9.5h-3.825" />
          </g>
        </svg>
        ;
      </Icon>
    );
  },
);

ResourceTask.displayName = 'ResourceTask';
